import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'iemType', method: 'GET', body: null, token: token })
}
